import Instance from '../../../utils/Axios';

const AdicionarTipoPeriodo = (ydata, show) => async (dispatch) => {
  await Instance()
    .post('/tipoperiodos/', { ydata })
    .then(({ data }) => {
      dispatch({ type: 'POST_TIPOPERIODO', payload: data });
      show('success', 'Tipo de período adicionado com sucesso!');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default AdicionarTipoPeriodo;
